module.exports = __webpack_public_path__ + "media/banks/bank-chase-dcbbbe54.png";